// 切詞：建置端、測試與瀏覽器端查詢共用這一支，不寫第二份。
// CJK（漢字、假名、諺文）每一段連續字切 unigram＋bigram，單字查詢（例如「眼」）也能命中；
// 其他文字用 \p{L}\p{N}+ 取詞，先 NFKC 再轉小寫。
const CJK_CLASS = '\\p{Script=Han}\\p{Script=Hiragana}\\p{Script=Katakana}\\p{Script=Hangul}'
const SEGMENT = new RegExp(`([${CJK_CLASS}]+)|((?:(?![${CJK_CLASS}])[\\p{L}\\p{N}])+)`, 'gu')

export const CJK_TEST = new RegExp(`[${CJK_CLASS}]`, 'u')
export const normalize = text => String(text ?? '').normalize('NFKC').toLowerCase()

function* segments(text) {
  for (const m of normalize(text).matchAll(SEGMENT)) yield m[1] ? { cjk: true, text: m[1] } : { cjk: false, text: m[2] }
}

// 索引端與一般查詢：CJK 段 → unigram＋bigram；其他 → 整詞
export function tokenize(text) {
  const out = []
  for (const seg of segments(text)) {
    if (!seg.cjk) { out.push(seg.text); continue }
    const chars = Array.from(seg.text)
    for (const c of chars) out.push(c)
    for (let i = 0; i + 1 < chars.length; i++) out.push(chars[i] + chars[i + 1])
  }
  return out
}

// 寬鬆查詢（AND 查無結果時改用 OR）：CJK 段只留 bigram（單字段才留 unigram），避免「的」「一」這類單字把全站撈出來
export function tokenizeLoose(text) {
  const out = []
  for (const seg of segments(text)) {
    if (!seg.cjk) { out.push(seg.text); continue }
    const chars = Array.from(seg.text)
    if (chars.length === 1) { out.push(chars[0]); continue }
    for (let i = 0; i + 1 < chars.length; i++) out.push(chars[i] + chars[i + 1])
  }
  return out
}

// 標題相等比較用：去掉所有非字母數字（含書名號、空白、標點）
export const squash = text => normalize(text).replace(/[^\p{L}\p{N}]+/gu, '')
